import { IUser, TLinkedUserListFilter } from '@contexts/UserContext/types';
import { faker } from '@faker-js/faker';

class LinkedUsers {
  currentPage = 1;
  initalData;
  data;
  totalElementCount;
  totalPage;
  limit;
  constructor({ size }: { size: number }) {
    this.initalData = Array.from({ length: size }, this.createMock);
    this.data = this.initalData;
    this.totalElementCount = size;
    this.totalPage = Math.ceil(size / this.limit);
  }

  createMock(): IUser {
    return {
      userId: faker.string.uuid(),
      ci: faker.string.uuid(),
      linkDate: faker.date.recent().toISOString(),
      email: faker.internet.email(),
      balance: faker.number.int({ min: 10, max: 100 }),
      numOfSbt: faker.number.int({ min: 10, max: 100 }),
      numOfVote: faker.number.int({ min: 10, max: 100 }),
      imageUrl: faker.image.avatar(),
    };
  }

  get({ requestPageNumber }: { requestPageNumber: number }) {
    const startIndex = (requestPageNumber - 1) * this.limit;
    const endIndex = startIndex + this.limit;

    return {
      currentPage: requestPageNumber,
      data: this.data.slice(startIndex, endIndex),
      totalElementCount: this.totalElementCount,
      totalPage: this.totalPage,
    };
  }

  getById({ userId }: { userId: string }) {
    return this.initalData.filter((item) => item.userId === userId)[0];
  }

  set({
    sortField,
    limit,
  }: {
    sortField: TLinkedUserListFilter;
    limit: number;
  }) {
    if (sortField === 'VOTE') {
      this.data = this.initalData.sort((a, b) => {
        const numOfVoteA = a.numOfVote;
        const numOfVoteB = b.numOfVote;

        if (isNaN(numOfVoteA) || isNaN(numOfVoteB)) {
          throw new Error('Invalid Number');
        }

        return numOfVoteB - numOfVoteA;
      });
    } else if (sortField === 'POINT') {
      this.data = this.initalData.sort((a, b) => {
        const balanceA = a.balance;
        const balanceB = b.balance;

        if (isNaN(balanceA) || isNaN(balanceB)) {
          throw new Error('Invalid Number');
        }
        return balanceB - balanceA;
      });
    } else {
      this.data = this.initalData.sort((a, b) => {
        const dateA = new Date(a.linkDate);
        const dateB = new Date(b.linkDate);

        if (isNaN(dateA.getTime()) || isNaN(dateB.getTime())) {
          throw new Error('Invalid date format');
        }

        return dateB.getTime() - dateA.getTime();
      });
    }
    this.limit = limit;
    this.totalElementCount = this.data.length;
    this.totalPage = Math.ceil(this.totalElementCount / this.limit);
  }
}

export const linkedUsers = new LinkedUsers({ size: 27 });
